import React, { useState } from 'react';
import { Button, Modal, Typography, Space, message } from 'antd';
import { PhoneOutlined } from '@ant-design/icons';

const ContactPhoneModal = ({onCancel,modalVisible, phoneNUm}) => {
//   const [modalVisible, setModalVisible] = useState(false);
  
  const phoneNumber = phoneNUm||'';


const copyPhone = async () => {
  if (!navigator.clipboard) {
    fallbackCopyToClipboard(phoneNumber);
    return;
  }

  try {
    await navigator.clipboard.writeText(phoneNumber);
    message.success("复制成功！");
  } catch (err) {
    console.error("Clipboard API error:", err);
    fallbackCopyToClipboard(phoneNumber);
  }
};

const fallbackCopyToClipboard = (text) => {
  const textArea = document.createElement("textarea");
  textArea.value = text;
  textArea.style.position = "fixed";
  textArea.style.top = "0";
  textArea.style.left = "0";
  textArea.style.opacity = "0";
  textArea.style.border = "none";
  textArea.style.padding = "0";
  textArea.style.margin = "0";
  textArea.style.overflow = "hidden";
  textArea.style.background = "transparent";

  document.body.appendChild(textArea);
  textArea.select();

  try {
    const successful = document.execCommand("copy");
    if (successful) {
      message.success("复制成功！");
    } else {
      message.error("复制失败，请手动复制");
    }
  } catch (err) {
    message.error("复制失败，请手动复制");
  }

  document.body.removeChild(textArea);
};


  return (
    <>

      <Modal
        title="联系我们" 
        open={modalVisible} 
        onCancel={onCancel}
        footer={null}
        width={300} 
        destroyOnClose 
      >
        <div style={{ textAlign: 'center', padding: '20px 0' }}>
          <Typography.Text strong style={{ fontSize: '16px', display: 'block', marginBottom: '15px' }}>
            客服热线
          </Typography.Text>
          
          <Space size="middle" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <a 
              href={`tel:${phoneNumber}`} 
              style={{ 
                fontSize: '20px', 
                color: '#1677ff', 
                textDecoration: 'none',
                cursor: 'pointer'
              }}
            >
              {phoneNumber}
            </a>
            
            <Button 
              type="text" 
              icon={<PhoneOutlined />} 
              onClick={copyPhone}
              style={{ display: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ? 'none' : 'inline-block' }}
            >
              复制号码
            </Button>
          </Space>
          
          <Typography.Text type="secondary" style={{ display: 'block', marginTop: '10px', fontSize: '12px' }}>
            {/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) 
              ? '点击号码直接拨号' 
              : '复制号码后使用电话软件拨打'}
          </Typography.Text>
        </div>
      </Modal>
    </>
  );
};

export default ContactPhoneModal;